exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul li[data-v-56304142]{margin-bottom:10px}ul li span[data-v-56304142]{display:inline-block}ul li span[data-v-56304142]:first-child{min-width:30px;padding-right:20px}ul li span[data-v-56304142]:last-child{padding-left:20px}", ""]);

// exports
